export const ResourceType = {
    NONE: 'none',
    JSON: 'json',
    MANIFEST: 'manifest'
};
